import { render, staticRenderFns } from "./AtomInputPrimary.vue?vue&type=template&id=8685b040"
import script from "./AtomInputPrimary.vue?vue&type=script&lang=js"
export * from "./AtomInputPrimary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports